export default __webpack_public_path__ + "static/media/client-09.8dd3cc70.webp";